<template>
  <div
    class="header-login"
    :class="{onn: scrollPosition > 41}"
  >
    <BlockUI
      :message="msg"
      :url="url"
      v-if="blockUi"
    ></BlockUI>

    <!-- advertisment bar -->
    <section id="topnav">
      <div class="container">
        <div class="row align-items-center py-2">

          <!-- offer area -->
          <div
            class="col-md-8 offers"
            v-if="instanceName !== 'MAHADEMY'"
          >
            <div v-if="checkOffer()">
              <div v-if="$store.getters.getOffers !== undefined && $store.getters.getOffers !== null && $store.getters.getOffers.length==1">
                <a>
                  {{$store.getters.getOffers[0].offerTitle}} <strong>OFFER CODE : </strong> {{$store.getters.getOffers[0].offerCode}}
                </a>
              </div>
              <div v-else>
                <!--slider here  -->
                <b><span>{{$t('offers.new_offers_available_soon')}}</span></b>
              </div>
            </div>
            <div v-else>
              <b><span>{{$t('offers.new_offers_available_soon')}}</span></b>
            </div>
          </div>

          <!-- course and playList -->
          <div
            class="col-md-4 user-links ml-auto"
            v-if="isLoggedIn !== undefined && isLoggedIn!== null && isLoggedIn"
          >
            <span class="nav-t">
              <router-link :to="{name:'myCourses'}">{{$t('common.labels.MyCourses')}}</router-link>
              <router-link
                v-if="instanceName !== 'MAHADEMY'"
                :to="{name:'playlist'}"
              >{{$t('playlist.labels.MyPlaylist')}}</router-link>
              <b-btn
                v-if="isMobileDevice()"
                @click="goOffline"
                class="router-link"
              >Go Offline</b-btn>
            </span>
          </div>

        </div>
      </div>
    </section>

    <!-- user arear -->
    <div id="main-header">
      <div class="container">
        <b-navbar toggleable="lg">

          <!-- <div :class="instanceName === 'mfslivedemy' ? 'row no-gutters align-items-center mfs-logo' : 'row no-gutters align-items-center'"> -->
          <div class="row no-gutters align-items-center">
            <div
              class="col col-lg-3 mfs-logo"
              v-if="instanceName === 'mfslivedemy'"
            >
              <router-link
                :to="{name:'home'}"
                class="navbar-brand"
              ><img
                  src="static/assets/images/mfs-logo.png"
                  alt="mfslivedemy"
                ></router-link>
            </div>
            <div
              class="col col-lg-3 maha-demy"
              v-if="instanceName === 'MAHADEMY'"
            >
              <router-link
                :to="{name:'home'}"
                class="navbar-brand"
              ><img
                  src="static/assets/images/mahademylogo.png"
                  alt="MAHADEMY"
                ></router-link>
            </div>
            <div
              class="col col-lg-3"
              v-if="instanceName === 'LIVEDEMY'"
            >
              <router-link
                :to="{name:'home'}"
                class="navbar-brand"
              ><img
                  src="static/assets/images/livedemy-logo-1.png"
                  alt="LIVEDEMY"
                ></router-link>
            </div>

            <div class="w-100 d-block d-md-none"></div>
            <div class="col-lg-6 col-collapse">
              <b-collapse
                is-nav
                id="nav_collapse"
                class="justify-content-center"
              >
                <div
                  v-if="checkNavStatus()"
                  class="m-links-holder"
                >
                  <!-- nav buttons -->
                  <div class="menu-links">

                    <!-- ===============>{{SSO_CLIENT_ID}} -->
                    <span
                      :class="$store.getters.getSearchType === 'all' ? 'active' : 'inActive'"
                      @click="goToSearchPage ('allBtn')"
                      @focus="goToSearchPage ('allBtn')"
                      tabindex="1"
                    >{{$t('common.labels.All')}}</span>
                    <span
                      v-if="instanceName !== 'MAHADEMY'"
                      :class="$store.getters.getSearchType === 'CO' ? 'active' : 'inActive'"
                      @click="goToSearchPage ('courseBtn')"
                      @focus="goToSearchPage ('courseBtn')"
                      tabindex="2"
                    >{{$t('common.labels.check_courses')}}</span>
                    <span
                      v-if="instanceName !== 'MAHADEMY'"
                      :class="$store.getters.getSearchType === 'LO' ? 'active' : 'inActive'"
                      @click="goToSearchPage ('libraryBtn')"
                      @focus="goToSearchPage ('libraryBtn')"
                      tabindex="3"
                    >{{$t('common.labels.surf_library')}}</span>
                  </div>
                </div>
                <!-- search section -->
                <div
                  v-else
                  class="m-search-holder"
                >
                  <Autocomplete
                    :resetAfter="false"
                    @tag="addTag"
                    ref="txt_search"
                    openDirection="bottom"
                    :searchable="true"
                    :value="searchText"
                    :preserveSearch="true"
                    @search-change="getSuggestions"
                    selectLabel="Search"
                    deselectLabel="Search"
                    selectedLabel="Search"
                    tag-placeholder="Search"
                    :taggable="true"
                    @select="onSearch"
                    @remove="onSearch"
                    :optionsLimit="5"
                    :placeholder="$t('common.labels.SearchPlaceHolder')"
                    :options="suggestions"
                    id="example-text-input"
                  >
                  </Autocomplete>
                  <!-- loader -->
                  <div
                    class="ms-loader"
                    v-if="loading !== undefined && loading !== null && loading && !checkNavStatus()"
                  >
                    <div class="loader-dr"></div>
                    <span class="sr-only">{{$t('searchPage.labels.loading')}}</span>
                  </div>
                </div>
              </b-collapse>
            </div>

            <div class="col col-lg-3">
              <div class="h-right">
                <!-- if user is logged in show cart, wallet, wishList -->
                <div
                  class="h-user"
                  v-if="isLoggedIn"
                >

                  <!-- <div class="icons-css"  v-if="!isAppEnvMahaDemy()"> -->
                  <div
                    class="icons-css"
                    v-if="instanceName !== 'MAHADEMY'"
                  >
                    <router-link
                      v-if="featureList&&featureList.wishlist"
                      :to="{name:'wishList'}"
                      class="wishlist  d-xs3-block"
                      tabindex="4"
                    >
                      <!-- <i class="mdi mdi-heart" title="Wishlist" aria-hidden="true"></i><span class="count">{{$store.getters.getWishListDataNotPresentInCart($store.getters.getCartData).length!= undefined && $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData).length != null && $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData).length > 0 ? $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData).length : ""}}</span> -->
                      <i
                        class="mdi mdi-heart"
                        title="Wishlist"
                        aria-hidden="true"
                      ></i><span :class="$store.getters.getWishListStoreData!= undefined && $store.getters.getWishListStoreData != null && $store.getters.getWishListStoreData.length > 0 ? 'count' :'' ">{{$store.getters.getWishListStoreData!= undefined && $store.getters.getWishListStoreData != null && $store.getters.getWishListStoreData.length > 0 ? $store.getters.getWishListStoreData.length : ""}}</span>
                    </router-link>

                    <router-link
                      v-if="featureList&&featureList.cart"
                      :to="{name:'cart'}"
                      class="cart"
                      tabindex="5"
                    >
                      <i
                        class="mdi mdi-cart"
                        title="Cart"
                        aria-hidden="true"
                      ></i><span :class="$store.getters.getCartData.items!= undefined && $store.getters.getCartData.items != null && $store.getters.getCartData.items.length > 0 ? 'count': ''">{{$store.getters.getCartData.items!= undefined && $store.getters.getCartData.items != null && $store.getters.getCartData.items.length > 0 ? $store.getters.getCartData.items.length: "" }}</span>
                    </router-link>
                    <router-link
                      v-if="featureList&&featureList.wallet"
                      :to="{name:'wallet'}"
                      class="wallet  d-xs3-block"
                      tabindex="6"
                    >
                      <i
                        class="mdi mdi-wallet"
                        title="Wallet"
                        aria-hidden="true"
                      ></i>
                    </router-link>
                  </div>
                  <!-- {{getUserDefaultCategory() !='MAHADEMY'}} -->
                  <div class="box-user">
                    <b-dropdown
                      variant="link"
                      right
                      no-caret
                    >
                      <template slot="button-content">
                        <img
                          v-if="basicProfile.profileImg != ''"
                          :src="basicProfile.profileImg"
                        >
                        <img
                          v-if="basicProfile.profileImg == ''"
                          src="static/assets/images/user.png"
                        >
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <!-- <b-dropdown-item :to="{name:'wishlist'}" class="d-block d-xs3-none"><i class="mdi mdi-heart"></i> {{$t('common.labels.your_wishlist')}}</b-dropdown-item>
                            <b-dropdown-item :to="{name:'wallet'}" class="d-block d-xs3-none"><i class="mdi mdi-wallet-membership"></i> {{$t('common.labels.your_wallet')}}</b-dropdown-item> -->
                      <b-dropdown-item :to="{name:'profile'}"><i class="mdi mdi-account-box-outline"></i> {{$t('common.labels.your_profile')}}</b-dropdown-item>
                      <!-- <b-dropdown-item to="wallet">Wallet</b-dropdown-item> -->
                      <!-- <b-dropdown-item v-if="!isAppEnvMahaDemy()" @click.prevent="logout"><i class="mdi mdi-power"></i> {{$t('common.labels.logout')}}</b-dropdown-item> -->
                      <b-dropdown-item
                        @click.prevent="logout"
                        v-if="instanceName !== 'MAHADEMY'"
                      ><i class="mdi mdi-power"></i> {{$t('common.labels.logout')}}</b-dropdown-item>
                      <!-- <b-dropdown-item v-if="isAppEnvMahaDemy()" @click.prevent="exitFromMahademy"><i class="mdi mdi-power"></i> {{$t('common.labels.logout')}}</b-dropdown-item> -->
                      <b-dropdown-item
                        @click.prevent="exitFromMahademy"
                        v-if="instanceName == 'MAHADEMY'"
                      ><i class="mdi mdi-power"></i> {{$t('common.labels.Back')}}</b-dropdown-item>
                    </b-dropdown>
                  </div>

                </div>
                <!-- if user is  not logged in then open b-model on specific action -->
                <div
                  v-else
                  class="h-links"
                >
                  <b-link
                    v-if="!isMobileDevice()"
                    @click="() => {
                          reset()
                          isLoginWithInvalidCredentials = false
                          this.$refs.loginModal.show()
                        }"
                  >{{$t('common.labels.log_in')}}
                  </b-link>
                  <b-link
                    v-else
                    @click="sendtoMobileLogin"
                  >{{$t('common.labels.log_in')}}
                  </b-link>
                  <b-link
                    v-if="featureList != null && featureList !=  undefined && featureList.signUp !== null && featureList.signUp !== undefined && featureList.signUp"
                    @click="() => {
                        resetPasswordPolicyFlags()
                          reset()
                          this.$refs.signupModal.show()
                        }"
                  >{{$t('common.labels.sign_up')}}
                  </b-link>

                </div>
                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
              </div>
            </div>

            <!-- modal for login -->
            <b-modal
              @shown="focusOnLoginModal"
              id="login"
              ref="loginModal"
              hide-footer
              title="Welcome back !"
              class="text-left"
            >
              <!-- <div class="social d-block">
                  <div class="sub-title">Sign in with</div>
                  <div class="d-flex">
                      <div>
                        <div class="fb"> <i class="fa fa-facebook"></i>Facebook</div>
                      </div>
                        <g-signin-button class="google"
                          :params="googleSignInParams"
                          @success="onSignInSuccess"
                          @error="onSignInError">
                          Google
                        </g-signin-button>

                        <fb-signin-button class="fb"
                          :params="fbSignInParams"
                          @success="onFBSignInSuccess"
                          @error="onSignInError">
                          Sign in with Facebook
                        </fb-signin-button>

                          <button @click="authenticate('twitter')">auth Twitter</button>

                      <div>
                        <div class="google"><i class="fa fa-google"></i>Google</div>
                      </div>
                      <div>
                        <div class="twitter"><i class="fa fa-twitter"></i>Twitter</div>
                      </div>
                  </div>
                </div>  -->
              <!-- <h5>OR</h5>  -->
              <div class="d-block">
                <!-- <div class="sub-title">Log In with </div> <hr> -->
                <!-- username -->
                <span
                  v-if="isLoginWithInvalidCredentials"
                  class="error"
                >Invalid login details !</span><br v-if="isLoginWithInvalidCredentials">
                <span class="sub-title">Email / Mobile no</span>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="email"
                  ><i class="fa fa-envelope"></i></span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="username"
                    placeholder="Enter email / mobile no"
                    aria-describedby="username"
                    ref="username"
                    id="username"
                    tabindex="7"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="emptyUsername && username.length === 0"
                  ><small>Username cannot be empty</small></span>
                </div>
                <!-- password -->
                <span class="sub-title">Password</span>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="password"
                  ><i class="fa fa-lock"></i></span>
                  <input
                    v-if="togglePasswordInputType"
                    type="password"
                    class="form-control with-icon"
                    v-model="password"
                    @keyup.enter="handleLogin"
                    placeholder="Enter password"
                    aria-describedby="password"
                    tabindex="8"
                  >
                  <input
                    v-else
                    type="text"
                    class="form-control with-icon"
                    v-model="password"
                    @keyup.enter="handleLogin"
                    placeholder="Enter password"
                    aria-describedby="password"
                    tabindex="8"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="emptyPassword && password.length === 0"
                  ><small>Password cannot be empty</small></span>
                  <span
                    class="input-icon mdi mdi-eye"
                    v-if="togglePasswordInputType"
                    @click="() => { togglePasswordInputType = false }"
                  ></span>
                  <span
                    class="input-icon mdi mdi-eye-off"
                    v-else
                    @click="() => {togglePasswordInputType = true}"
                  ></span>
                </div>
                <!-- forget password -->
                <div class="forgotpwd d-flex"><a
                    href="#"
                    @click="() => {
                      resetPasswordPolicyFlags()
                      reset()
                      this.$refs.forgetPasswordModal.show()
                    }"
                    tabindex="-1"
                  >Forgot Password?</a></div>
              </div>
              <!-- login btn -->
              <b-btn
                block
                @click="handleLogin"
                class="btn-large login-btn"
                variant="outline-danger"
                @keypress.enter="handleLogin"
                tabindex="6"
              >Login</b-btn>
              <!-- sign up btn -->
              <div
                v-if="featureList != null && featureList !=  undefined && featureList.signUp !== null && featureList.signUp !== undefined  && featureList.signUp"
                @click="() => {
                  reset()
                  resetPasswordPolicyFlags()
                  this.$refs.signupModal.show()
                }"
                class="d-flex justify-content-center sub-title newuser"
              >New User? &nbsp;<a
                  href="#"
                  tabindex="7"
                >Sign Up</a></div>
            </b-modal>

            <!-- modal for signup -->
            <b-modal
              @shown="focusOnSignUpModal"
              id="signup"
              ref="signupModal"
              hide-footer
              title="Sign up and start learning now!"
              class="text-left"
            >
              <!-- <div class="social d-block">
                    <div class="sub-title">Sign Up with Social Media</div>
                    <div class="d-flex">
                        <div>
                          <div class="fb"> <i class="fa fa-facebook"></i> Facebook</div>
                        </div>
                        <div>
                          <div class="google"><i class="fa fa-google"></i> Google</div>
                        </div>
                        <div>
                          <div class="twitter"><i class="fa fa-twitter"></i> Twitter</div>
                        </div>
                    </div>
                  </div>
                  <h5>OR</h5> -->
              <div class="d-block">
                <!-- <div class="sub-title">Sign Up with</div> <hr> -->

                <!-- full name -->
                <span class="sub-title">Full Name</span>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="fullname"
                  ><i class="fa fa-envelope"></i></span>
                  <input
                    type="text"
                    v-validate="{rules:{required: true, regex: /^[a-zA-Z ]*$/}}"
                    class="form-control"
                    v-model="fullname"
                    placeholder="Enter your full name"
                    aria-describedby="fullname"
                    name="fullname"
                    ref="fullName"
                    autofocus
                    tabindex="8"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="errors.has('fullname')"
                  ><small>{{ errors.first('fullname') }}</small></span>
                </div>

                <!-- email -->
                <span class="sub-title">Email</span>
                <div class="input-group">
                  <!-- @blur ="() => {assignError(errors.has('email'), 'email', email)}" -->
                  <span
                    v-if="emailAlreadyInUse"
                    class="w-100 text-danger"
                  >Email id already in use</span>
                  <span
                    class="input-group-addon"
                    id="email"
                  ><i class="fa fa-envelope"></i></span>
                  <input
                    name="email"
                    v-validate="'required|email'"
                    type="email"
                    class="form-control"
                    v-model="email"
                    placeholder="Your email ID"
                    aria-describedby="email"
                    tabindex="9"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="errors.has('email') && email.length != 0"
                  ><small>{{ errors.first('email') }}</small></span>
                </div>

                <!-- mobile -->
                <!-- @blur  ="() => {assignError(errors.has('mobilenumber'), 'mobilenumber', mobile)}" -->
                <span class="sub-title">Mobile</span>
                <div class="input-group">
                  <span
                    v-if="mobileAlreadyInUse"
                    class="w-100 text-danger"
                  >Mobile number already in use</span>
                  <span
                    class="input-group-addon"
                    id="mobile"
                  ><i class="fa fa-lock"></i></span>
                  <input
                    v-validate="'required|numeric|length:10'"
                    name="mobile number"
                    class="form-control"
                    v-model="mobile"
                    placeholder="Enter mobile"
                    aria-describedby="mobile"
                    tabindex="10"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="errors.has('mobile number') && mobile.length != 0"
                  ><small>{{ errors.first('mobile number') }}</small></span>
                </div>

                <!-- password -->
                <span class="sub-title">Password</span>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="password"
                  ><i class="fa fa-lock"></i></span>
                  <input
                    v-if="togglePasswordInputType"
                    v-validate="'required'"
                    name="password"
                    type="password"
                    class="form-control with-icon"
                    @keyup.enter="handleRegistration()"
                    v-model="password"
                    placeholder="Enter password"
                    aria-describedby="password"
                    @input="validatePasswordInput(password)"
                    tabindex="11"
                  >
                  <input
                    v-else
                    v-validate="'required'"
                    name="password"
                    type="text"
                    class="form-control with-icon"
                    @keyup.enter="handleRegistration()"
                    v-model="password"
                    placeholder="Enter password"
                    aria-describedby="password"
                    @input="validatePasswordInput(password)"
                    tabindex="11"
                  >
                  <span
                    class="w-100 text-danger"
                    v-show="errors.has('password') && password.length != 0"
                  ><small>{{ errors.first('password') }}</small></span>
                  <!-- <span  class="mdi mdi-help-circle ml-auto help-icon" v-b-popover.hover="'Password must have at least 4 characters & at least one capital alphabet'" title="Password Guidelines"></span> -->
                  <span
                    class="input-icon mdi mdi-eye"
                    v-if="togglePasswordInputType"
                    @click="() => { togglePasswordInputType = false }"
                  ></span>
                  <span
                    class="input-icon mdi mdi-eye-off"
                    v-else
                    @click="() => {togglePasswordInputType = true}"
                  ></span>
                </div>
                <!--  -->
                <!-- <div class="input-group">
                      <span class="input-group-addon" id="password"><i class="fa fa-lock"></i></span>
                      <input v-if ="togglePasswordInputType" type="password" class="form-control with-icon" v-model="password" @keyup.enter= "handleLogin" placeholder="Enter password" aria-describedby="password" tabindex="8">
                      <input v-else type="text" class="form-control with-icon" v-model="password" @keyup.enter= "handleLogin" placeholder="Enter password" aria-describedby="password" tabindex="8">
                      <span class="w-100 text-danger" v-show ="emptyPassword && password.length === 0"><small>Password cannot be empty</small></span>
                      <span class ="input-icon mdi mdi-eye" v-if="togglePasswordInputType"  @click="() => { togglePasswordInputType = false }"></span>
                      <span class ="input-icon mdi mdi-eye-off" v-else @click="() => {togglePasswordInputType = true}"></span>
                    </div>  -->
                <div>
                  <span>Password must have: </span>
                  <ul>
                    <li v-show="!strike_cap_alpha"> At least 1 capital alphabet </li>
                    <li
                      v-show="strike_cap_alpha"
                      class="strikethrough"
                    > At least 1 capital alphabet </li>
                    <li v-show="!strike_length"> At least 4 characters </li>
                    <li
                      v-show="strike_length"
                      class="strikethrough"
                    > At least 4 characters </li>
                  </ul>
                </div>
              </div>

              <!-- t&c -->
              <!-- <div class=" sub-title newusertc">By signing up I accept the <a href="#">terms and conditions</a> of Livedemy and request to subscribe for latest offers</div>  -->
              <!-- signup -->
              <b-btn
                @click="handleRegistration()"
                class="btn-large col-12 login-btn"
                variant="outline-danger"
                tabindex="12"
              >Sign Up</b-btn>
              <div
                @click="() => {
                  reset()
                  this.$refs.loginModal.show()
                }"
                class="d-flex justify-content-center sub-title newuser"
              >Already have an account? &nbsp;<a
                  href="#"
                  tabindex="13"
                >Login</a></div>
            </b-modal>

            <!-- modal for forget password -->
            <b-modal
              @shown="focusOnForgetPasswordModal"
              id="forgetPassword"
              ref="forgetPasswordModal"
              hide-footer
              title="Forgot Password?"
              class="text-left"
            >
              <div class="d-block">
                <!-- username{{isOtpRequestSend}} -->
                <div
                  v-if="!isOtpRequestSend"
                  class="sub-title"
                >Email / mobile no</div>
                <div
                  v-if="!isOtpRequestSend"
                  class="input-group"
                >
                  <span
                    v-if="invalidUsernameOtp"
                    class="w-100 text-danger"
                  > Invalid details entered</span>
                  <span
                    class="input-group-addon"
                    id="name"
                  ><i class="fa fa-user"></i></span>
                  <input
                    type="text"
                    ref="usernameForgotInput"
                    v-model="username"
                    class="form-control"
                    placeholder="Enter email / mobile no"
                    aria-describedby="text"
                    tabindex="14"
                    autofocus
                  >
                </div>
                <br v-if="!isOtpRequestSend">
                <!-- otp -->
                <div
                  v-if="isOtpRequestSend"
                  class="sub-title"
                >Enter OTP</div>
                <div
                  v-if="isOtpRequestSend"
                  class="input-group"
                >
                  <span
                    class="input-group-addon"
                    id="email"
                  ><i class="fa fa-envelope"></i></span>
                  <input
                    type="text"
                    @keyup="validateForNumberInput(otpInput, false)"
                    v-validate="'required|numeric'"
                    class="form-control"
                    v-model="otpInput"
                    placeholder="Enter OTP"
                    aria-describedby="email"
                    tabindex="18"
                    autofocus
                  >

                  <small
                    v-if="invalidOtp"
                    class="w-100 text-danger"
                  >Oops! The OTP you've entered is invalid, try entering it again, else click on resend OTP link below</small>

                  <!-- <b-link class="w-100 resend-otp" v-if ="isOtpRequestSend" @click="handleOtpResend()">Resend OTP</b-link> -->
                </div>
              </div>
              <div tabindex="15">
                <b-link
                  class="w-100 resend-otp"
                  v-if="isOtpRequestSend"
                  @click="handleOtpResend()"
                >Resend OTP</b-link>
              </div>
              <!-- check for email -->
              <b-form-group v-if="!isOtpRequestSend">
                <b-form-checkbox-group
                  id="otpcheck"
                  v-model="otpOptions"
                  name=""
                  :options="optOnMail"
                  ref="otpcheckRef"
                >
                </b-form-checkbox-group>
              </b-form-group>
              <!-- send otp btn -->
              <b-btn
                block
                v-if="!isOtpRequestSend"
                @click="handleOtpRequest"
                class="btn-large login-btn"
                variant="outline-danger"
                tabindex="17"
              >Send OTP</b-btn>
              <!-- verify otp btn -->
              <br v-if="isOtpRequestSend">
              <b-btn
                block
                v-if="isOtpRequestSend"
                @click="handleOtpVerification"
                class="btn-large login-btn"
                variant="outline-danger"
                tabindex="19"
              >Verify OTP</b-btn>
            </b-modal>

            <!-- modal for entering new Password -->
            <b-modal
              id="passwordChange"
              ref="passwordChangeModal"
              hide-footer
              title="Change password"
              class="text-left"
            >
              <div class="d-block">
                <div class="sub-title">New password</div>
                <span
                  class="w-100 text-danger"
                  v-if="passwordMismatch"
                >Password doesn't match</span>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="name"
                  ><i class="fa fa-user"></i></span>
                  <input
                    v-if="togglePasswordInputType"
                    ref="newPasswordInputField"
                    type="password"
                    v-model="password"
                    class="form-control with-icon"
                    placeholder="Enter new password"
                    aria-describedby="text"
                    @input="validatePasswordInput(password)"
                    tabindex="20"
                  >
                  <input
                    v-else
                    ref="newPasswordInputField"
                    type="text"
                    v-model="password"
                    class="form-control with-icon"
                    placeholder="Enter new password"
                    aria-describedby="text"
                    @input="validatePasswordInput(password)"
                    tabindex="20"
                  >
                  <!-- <span  class="mdi mdi-help-circle ml-auto help-icon" v-b-popover.hover="'Password must have at least 4 characters & at least one capital alphabet'" title="Password Guidelines"></span> -->
                  <span
                    class="input-icon mdi mdi-eye"
                    v-if="togglePasswordInputType"
                    @click="() => { togglePasswordInputType = false }"
                  ></span>
                  <span
                    class="input-icon mdi mdi-eye-off"
                    v-else
                    @click="() => {togglePasswordInputType = true}"
                  ></span>
                </div>

                <!-- <div class="input-group">
                      <span class="input-group-addon" id="password"><i class="fa fa-lock"></i></span>
                      <input v-if ="togglePasswordInputType" type="password" class="form-control with-icon" v-model="password" @keyup.enter= "handleLogin" placeholder="Enter password" aria-describedby="password" tabindex="8">
                      <input v-else type="text" class="form-control with-icon" v-model="password" @keyup.enter= "handleLogin" placeholder="Enter password" aria-describedby="password" tabindex="8">
                      <span class="w-100 text-danger" v-show ="emptyPassword && password.length === 0"><small>Password cannot be empty</small></span>
                      <span class ="input-icon mdi mdi-eye" v-if="togglePasswordInputType"  @click="() => { togglePasswordInputType = false }"></span>
                      <span class ="input-icon mdi mdi-eye-off" v-else @click="() => {togglePasswordInputType = true}"></span>
                    </div>  -->
                <!-- <b-link v-if ="!isShown" @click="() => {$refs.newPasswordInputField.setAttribute('type','text') ; isShown = true }">show</b-link>
                  <b-link v-if = isShown @click="() => {$refs.newPasswordInputField.setAttribute('type','password'); isShown = false}" >Hide</b-link> -->
                <!-- <div v-show="showSpecialCharErr">
                    <span class="text-danger"><small>Special characters and spaces are not allowed in password</small></span>
                  </div> -->
                <div>
                  <span>Password must have: </span>
                  <ul>
                    <li v-show="!strike_cap_alpha"> At least 1 capital alphabet </li>
                    <li
                      v-show="strike_cap_alpha"
                      class="strikethrough"
                    > At least 1 capital alphabet </li>
                    <li v-show="!strike_length"> At least 4 characters </li>
                    <li
                      v-show="strike_length"
                      class="strikethrough"
                    > At least 4 characters </li>
                  </ul>
                </div>
                <div class="sub-title">Confirm Password</div>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    id="name"
                  ><i class="fa fa-user"></i></span>
                  <input
                    type="password"
                    v-model="confirmPassword"
                    class="form-control"
                    placeholder="Confirm password"
                    aria-describedby="text"
                    tabindex="21"
                  >
                </div>
              </div>
              <br>
              <!-- {{isLinkingOperationPerformed}} -->
              <b-btn
                block
                v-if="isLinkingOperationPerformed"
                @click="handleCommonPasswordRequest"
                class="btn-large login-btn"
                variant="outline-danger"
              >Submit</b-btn>
              <b-btn
                block
                v-else
                @click="handlePasswordReset"
                class="btn-large login-btn"
                variant="outline-danger"
                tabindex="22"
              >Change Password</b-btn>
              <!-- <div class="d-flex justify-content-center sub-title newuser">New User? &nbsp;<a href="#">Sign Up</a></div> -->
            </b-modal>

            <!-- modal for entering madatory field during registration -->
            <b-modal
              id="mobileNumber"
              ref="mobileNumberModal"
              hide-footer
              title="Welcome to Livedemy!"
              class="text-left"
            >
              <div class="d-block">
                <div class="sub-title">Contact no</div>
                <div class="input-group">
                  <input
                    type="text"
                    v-model="mobile"
                    class="form-control"
                    placeholder="Enter contact no"
                    aria-describedby="text"
                  >
                </div>
              </div>

              <b-btn
                block
                @click="enrollGoogleUser()"
                class="btn-large login-btn"
                variant="outline-danger"
              >Submit</b-btn>
              <!-- <div class="d-flex justify-content-center sub-title newuser">New User? &nbsp;<a href="#">Sign Up</a></div> -->
            </b-modal>

            <!-- modal for getting additional info from third party user -->
            <b-modal
              id="registrationInfo"
              ref="registrationInfoModal"
              hide-footer
              title="Welcome to Livedemy!"
              class="text-left"
            >
              <div class="d-block">
                <div
                  class="sub-title"
                  v-if="showContact"
                >Contact no</div>
                <div
                  class="input-group"
                  v-if="showContact"
                >
                  <input
                    type="text"
                    v-model="thirdPartyUserObj.mobile"
                    class="form-control"
                    placeholder="Enter contact no"
                    aria-describedby="text"
                  >
                </div>
                <div
                  class="sub-title"
                  v-if="showEmail"
                >Email address</div>
                <div
                  class="input-group"
                  v-if="showEmail"
                >
                  <input
                    type="text"
                    v-model="thirdPartyUserObj.email"
                    class="form-control"
                    placeholder="Enter email address"
                    aria-describedby="text"
                  >
                </div>
              </div>

              <b-btn
                block
                @click="enrollThirdPartyUser()"
                class="btn-large"
                variant="outline-danger"
              >Submit</b-btn>
            </b-modal>

            <!-- modal asking user to validate email and mobile -->
            <b-modal
              id="askCredential"
              ref="askCredentialModal"
              hide-footer
              title="Hey, user we do not have any contact details associated with user. Please enter contact details"
              class="text-left"
            >
              <div class="d-block">
                <!-- <div class="sub-title" v-if="askForMobile">Contact no</div>
                  <div class="input-group" v-if="askForMobile">
                      <input type="text" v-model="mobile" class="form-control" placeholder="Enter contact no" aria-describedby="text">
                  </div>                     -->
                <div
                  class="sub-title"
                  v-if="!isContactDetailsOtpSend"
                >Mobile number</div>
                <div
                  class="input-group"
                  v-if="!isContactDetailsOtpSend"
                >
                  <input
                    type="text"
                    v-model="userEnteredValue"
                    class="form-control"
                    placeholder="Enter mobile number"
                    aria-describedby="text"
                  >
                </div>
                <div
                  class="sub-title"
                  v-if="isContactDetailsOtpSend"
                >OTP</div>
                <div
                  class="input-group"
                  v-if="isContactDetailsOtpSend"
                >
                  <input
                    type="number"
                    v-model="otpInput"
                    class="form-control"
                    placeholder="Enter OTP"
                    aria-describedby="text"
                  >
                </div>

              </div>
              <b-btn
                block
                v-if="!isContactDetailsOtpSend"
                @click="checkContactDetails()"
                class="btn-large"
                variant="outline-danger"
              >Send OTP</b-btn>
              <b-btn
                block
                v-if="isContactDetailsOtpSend"
                @click="contactDetailsOtpVerification()"
                class="btn-large"
                variant="outline-danger"
              >Verify OTP</b-btn>
            </b-modal>

            <b-modal
              id="otpVerificationForAccountLinking"
              ref="otpVerificationForAccountLinkingModal"
              hide-footer
              title="Hey, user we do not have any contact details associated with user. Please enter contact details"
              class="text-left"
            >
              <div class="d-block">
                <div class="sub-title">OTP </div>
                <div class="input-group">
                  <input
                    type="text"
                    v-model="userEnteredValue"
                    class="form-control"
                    placeholder="Enter OTP"
                    aria-describedby="text"
                  >
                </div>
              </div>
              <b-btn
                block
                @click="verifyOtp(userEnteredValue)"
                class="btn-large"
                variant="outline-danger"
              >Send OTP</b-btn>
              <!-- <b-btn block v-if="isContactDetailsOtpSend" @click="contactDetailsOtpVerification()" class="btn-large" variant="outline-danger">Verify OTP</b-btn>  -->
            </b-modal>

          </div>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
function sendMessageToAndroid(message) {
  Android.sendMessage(message);
}
/* eslint-disable */
import { ErrorBag } from "vee-validate";
import {
  SSO_URL,
  SSO_CLIENT_ID,
  THIRDPARTY_GOOGLE_USER,
  THIRDPARTY_FACEBOOK_USER,
  LIVEDEMY_DEFAULT_USER,
  LIVEDEMY_DEFAULT_USER_RIGHT,
  DEFAULT_OBJECT_CATEGORY,
  MAHADEMY_EXIT_URL,
  INSTANCE_NAME,
  MAHADEMY_APP_ENV
} from "@/components/common/constants.js";
import {
  EventBus,
  facebookUserDetails,
  encrtpyDetailsUsingMd5
} from "@/main.js";
import axios from "axios";
import Autocomplete from "@/components/autocomplete";
import Vue from "vue";
import BlockUI from "vue-blockui";
Vue.use(BlockUI);
export default {
  name: "headerLogin",
  props: ["status"],
  components: { Autocomplete },
  data() {
    return {
      signUpStatus: true,
      togglePasswordInputType: true,
      app_env: null,
      tempUsername: "",
      isLinkingOperationPerformed: false,
      displayName: "",
      options: {
        enablePrivilege: true,
        consumerKey: "4ifqJFwVtJ3aq15rfNeUAUzcW",
        consumerSecret: "f3lDB7ep4nsFdL7lGmNjKsgmg8FiagPXwvwN14BWdBcQq84Gbq"
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: true
      },
      googleSignInParams: {
        client_id:
          "844613137140-ac3fpcc37b20oi00mockao9h43mpu0f2.apps.googleusercontent.com"
      },
      msg: "Please wait...",
      url: "static/assets/images/Spinner.svg", // It is important to import the loading image then use here
      blockUi: false,
      tokenForPasswordChange: "",
      mobileAlreadyInUse: false,
      emailAlreadyInUse: false,
      optOnMail: [{ text: "Send OTP on email", value: true }],
      obj: {
        fullname: false,
        DOB: false,
        gender: false,
        email: false,
        mobilenumber: false,
        username: false
      },
      genderList: [
        { text: "Male", value: "M" },
        { text: "Female", value: "F" }
      ],
      signUpObj: {
        contactDetails: {
          email: {
            address: null
          },
          mobile: {
            number: null,
            verifiedOn: null
          }
        },
        personalDetails: {
          dob: null,
          fullName: null,
          gender: null
        },
        userName: null,
        password: null
      },
      config: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      errorList: [],
      showUsernameSuggestion: false,
      suggestedUserName: [],
      isLoginWithInvalidCredentials: false,
      genderSelected: "",
      emptyUsername: false,
      emptyPassword: false,
      date: "",
      fullname: "",
      DOB: "",
      gender: "",
      email: "",
      mobile: "",
      username: "",
      password: "",
      otpInput: "",
      confirmPassword: "",
      isShown: false,
      otpOptions: [],
      isOtpRequestSend: false,
      loading: false,
      scrollPosition: null,
      isValidUser: false,
      suggestions: [],
      wordlist: [],
      searchText: "",
      queryText: "",
      latitude: 0,
      longitude: 0,
      invalidUsernameOtp: false,
      invalidOtp: false,
      passwordMismatch: false,
      defaultOptions: {
        maximumAge: 0,
        timeout: 2000,
        enableHighAccuracy: false
      },
      bag: new ErrorBag(),
      profile: "",
      userNameForPasswordReset: "",
      thirdPartyUserObj: {
        email: "",
        mobile: "",
        userName: "",
        jvId: "",
        mkclIdentificationNumber: ""
      },
      askForMobile: false,
      askForEmail: false,
      showContact: false,
      showEmail: false,
      showPasswordHint: false,
      // passwordChangeAuth: ''
      mobileDevice: false,
      caseFalse: false,
      userEnteredValue: "",
      afficilator: "",
      profileId: "",
      usernameFromAfficilatorApi: "",
      strike_length: false,
      strike_cap_alpha: false,
      strike_no_char: "",
      showSpecialCharErr: false,
      isContactDetailsOtpSend: false,
      isMultipleAccount: false,
      isLinkingPermission: false,
      associatedProfileId: "",
      contactMobile: "",
      livedemyEnv: localStorage.getItem("app_env"),
      instanceName: INSTANCE_NAME,
      featureList: null
    };
  },
  created() {
    // this.mobileDevice = this.$route.params.mobileDevice
    this.mobileDevice = localStorage.getItem("mobileDevice");
    // this.getSignUpStatus()
    // this.app_env = local
    // initializeFaceBookSDK()
  },
  methods: {
    focusOnForgetPasswordModal(e) {
      this.$refs.usernameForgotInput.focus();
    },
    focusOnSignUpModal(e) {
      this.$refs.fullName.focus();
    },
    focusOnLoginModal(e) {
      this.$refs.username.focus();
    },
    isAppEnvMahademy() {
      if (
        localStorage.getItem("app_env") !== null &&
        localStorage.getItem("app_env") !== undefined &&
        localStorage.getItem("app_env") === MAHADEMY_APP_ENV
      ) {
        return true;
      }
      return false;
    },
    getUserDefaultCategory() {
      return LIVEDEMY_DEFAULT_USER;
    },
    // isMobileDevice - returns status indicating whether user is logged in on mobile device or not
    isMobileDevice() {
      return localStorage.getItem("mobileDevice");
    },
    // checkForTabOrSpaces - check for tab or space in ip
    // return true if space of tab found
    checkForTabOrSpaces(ip) {
      return new Promise(resolve => {
        for (var i = 0; i < ip.length; i++) {
          if (ip.charCodeAt(i) === 9 || ip.charCodeAt(i) === 32) {
            resolve(true);
          }
        }
        resolve(false);
      });
    },
    // countCapitalAlphabets - returns number of capital alphabets in ip
    countCapitalAlphabets(ip) {
      return new Promise(resolve => {
        var count = 0;
        for (var i = 0; i < ip.length; i++) {
          if (ip.charCodeAt(i) >= 65 && ip.charCodeAt(i) <= 90) {
            count++;
          }
        }
        resolve(count);
      });
    },
    // validatePasswordInput - checks whether password is valid according to rules
    // rules : no tab or space, length min 12, one capital letter, must contain at least one number, no rule for special character
    // returns false if invalid password else true
    validatePasswordInput(ip) {
      return new Promise(resolve => {
        if (ip.length !== 0) {
          // check length
          if (ip.length >= 4) {
            this.strike_length = true;
          } else {
            this.strike_length = false;
            resolve(false);
          }
          this.countCapitalAlphabets(ip).then(res => {
            if (res === 0 || res < 1) {
              // check if ip has no capital letter or more than one capital letter
              this.strike_cap_alpha = false;
              // return false // ip has no or more than one capital letter
              resolve(false); // ip has no or more than one capital letter
            } else {
              this.strike_cap_alpha = true;
              resolve(true);
              /* var numList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
              for (var i = 0; i < ip.length; i++) {
                if (numList.includes(parseInt(ip[i]))) {
                  resolve(true) // valid passwword
                }/*  else {
                  if (i + 1 === ip.length) {
                    resolve(false) // ip has no numeric h=characters
                  }
                }
              } */
            }
          });
        } else {
          // console.log('l f')
          this.strike_cap_alpha = false;
          resolve(false);
        }
      });
    },
    // goOffline - used for android app
    goOffline() {
      sendMessageToAndroid("go-offline");
    },
    // sendtoMobileLogin - used for android app
    sendtoMobileLogin() {
      sendMessageToAndroid("login");
    },
    // validateForNumberInput - checks whether ip value contains number or alphabet
    // parameter toReturnError - decides whether to return error or simply toast it
    // returns false if contains alphabet
    validateForNumberInput(ip, toReturnError) {
      var numList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      for (var val = 0; val < ip.split("").length; val++) {
        if (numList.includes(parseInt(ip[val])) === false) {
          if (!toReturnError) {
            // donot return the error
            this.$toasted.error("OTP must contain only numeric characters");
            break;
          } else {
            // return the error
            return false;
          }
        } else {
          if (val + 1 === ip.split("").length) {
            return true;
          }
        }
      }
    },
    // validateForTextInput - checks whether ip value contains alphabetic or non - alphabetic characters
    // parameter toReturnError - decides whether to return error or simply toast it
    // returns false if constains non - alphabetic characters
    validateForTextInput(ip, toReturnError) {
      var ipList = ip
        .trim("")
        .replace(/\s/g, "")
        .toLowerCase()
        .split("");
      var alphabet = "abcdefghijklmnopqrstuvwxyz";
      var alphabetList = alphabet.split("");
      for (var i = 0; i < ipList.length; i++) {
        if (alphabetList.includes(ipList[i]) === false) {
          if (!toReturnError) {
            // toast the error
            this.$toasted.error(
              "Input must not contain any non alphabetic charaters"
            );
          } else {
            // return the error
            return false;
          }
        } else {
          if (i + 1 === ipList.length) {
            return true;
          }
        }
      }
    },
    // enrollThirdPartyUser - resgister the third party data
    enrollThirdPartyUser() {
      this.showContact = false;
      this.showEmail = false;
      if (this.thirdPartyUserObj.email.length === 0) {
        this.thirdPartyUserObj.userName = this.thirdPartyUserObj.email;
      }
      /*
        steps for registration :
        1. enroll user in liveDemy db
        2. create token for user
        3. store token and set flags
        4. logged in user
      */
      return new Promise((resolve, reject) => {
        var registrationObject = {
          userName: this.thirdPartyUserObj.email,
          email: this.thirdPartyUserObj.email,
          mobile: this.thirdPartyUserObj.mobile,
          mkclIdentificationNumber: this.thirdPartyUserObj
            .mkclIdentificationNumber
        };
        axios
          .post("o/enrollNewUser", registrationObject)
          .then(res => {
            // step 1 success [enroll user in liveDemy db]
            axios
              .post("o/createTokenForSocialUser", {
                userName: this.thirdPartyUserObj.email
              })
              .then(res => {
                // step 2 success [create token for user]
                /*
              set information to be set in local storage
              token => created by liveDemy server
              isLoggedin => flag to be seted for mantaining session storage accross multiple tabs
              ssoToken => flag to be seted if token is generated by sso server
            */
                localStorage.setItem("token", res.data);
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("ssoToken", false);
                // step 3 success [store token and set flags]
                this.$store.dispatch("signInThirdPartyUser", res.data).then(
                  res => {
                    // step 4 success [logged in user]
                    // this.$refs.loginModal.hide()
                    resolve();
                  },
                  error => {
                    console.log("ERROR_IN_SIGN_IN : ", error);
                    reject(error);
                  }
                );
              })
              .catch(err => {
                console.log("ERROR_IN_CREATING_TOKEN :", err);
                reject(err);
              });
          })
          .catch(err => {
            console.log("ERROR_IN_ENROLLING_NEW_USER : ", err);
            reject(err);
          });
      });
    },
    // resetThirdPartyUserObj - clear previous data
    resetThirdPartyUserObj() {
      this.thirdPartyUserObj.email = "";
      this.thirdPartyUserObj.mobile = "";
      this.thirdPartyUserObj.userName = "";
      this.thirdPartyUserObj.jvId = "";
      this.thirdPartyUserObj.mkclIdentificationNumber = "";
    },
    // storeThirdPartyData - called when user login for 1st time
    storeThirdPartyData(thirdParty, dataFromThirdParty) {
      this.resetThirdPartyUserObj();
      if (
        dataFromThirdParty.name !== undefined ||
        dataFromThirdParty.name !== null
      ) {
        this.displayName = dataFromThirdParty.name;
      }
      if (thirdParty === THIRDPARTY_FACEBOOK_USER) {
        this.thirdPartyUserObj.mkclIdentificationNumber = dataFromThirdParty.id;
        this.showContact = true;
        this.showEmail = true;
        this.$refs.registrationInfoModal.show();
      } else if (thirdParty === THIRDPARTY_GOOGLE_USER) {
        this.thirdPartyUserObj.mkclIdentificationNumber =
          dataFromThirdParty.email;
        this.showContact = true;
        this.thirdPartyUserObj.email = dataFromThirdParty.email;
        this.userName = dataFromThirdParty.email;
        this.$refs.registrationInfoModal.show();
      }
    },
    // onFBSignInSuccess - mtd called on successfull sign In from facebook
    onFBSignInSuccess(response) {
      facebookUserDetails().then(res => {
        this.storeThirdPartyData(THIRDPARTY_FACEBOOK_USER, res);
      });
    },
    onSignInSuccess(googleUser) {
      return new Promise((resolve, reject) => {
        this.blockUi = true;
        axios
          .post("o/verifySocialMediaUser", { profileId: googleUser.El })
          .then(res => {
            // console.log(JSON.stringify(res))
            if (
              res.status === 200 &&
              res.data.remark === "IDENTIFICATION_NUMBER_NOT_REGISTERED"
            ) {
              this.blockUi = false;
              this.$toasted.error(
                "Google account is not linked with livedemy..."
              );
              // this.$refs.loginModal.hide()
              resolve();
            } else if (res.status === 200 && res.data.remark === "SUCCESS") {
              this.$store
                .dispatch("setUserStoreData", res.data.userData)
                .then(storeResponse => {
                  if (storeResponse) {
                    localStorage.setItem("isLoggedIn", true);
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem("ssoToken", false);
                    this.$toasted.success("Welcome user...");
                    this.blockUi = false;
                    this.$refs.loginModal.hide();
                  }
                });
            }
          })
          .catch(err => {
            this.blockUi = false;
            // this.$refs.loginModal.hide()
            console.log(err);
            this.$toasted.error("Error while signing in with Google..");
            reject();
          });
      });
    },
    onSignInError(error) {
      this.$toasted.error("Something went wrong... please try again");
      // `error` contains any error occurred.
      console.log("ERROR_WHILE_THIRD_PARTY_SIGN_IN : ", error);
    },
    assignError(isError, fieldName, value) {
      this.obj[fieldName] = isError;
      if (fieldName === "email" && !isError) {
        // alert(value)
        this.isDuplicateEmailOrMobile("email", value);
      } else if (fieldName === "mobilenumber" && !isError) {
        this.isDuplicateEmailOrMobile("mobile", value);
      }
    },
    // isAnyFieldBlank - checks whether feilds are blank during sign up
    isAnyFieldBlank() {
      if (this.email !== "") {
        if (this.mobile !== "") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkForUsernameAvailability(username) {
      // return new Promise((resolve, reject) => {
      if (!this.checkForError() && !this.isAnyFieldBlank()) {
        this.signUpObj.personalDetails.fullName = this.email;
        this.signUpObj.contactDetails.email.address = this.email;
        this.signUpObj.contactDetails.mobile.number = this.mobile;
        this.signUpObj.userName = this.username;
        return new Promise((resolve, reject) => {
          axios
            .post(SSO_URL + "/o/isUsernameAvailable", this.signUpObj)
            .then(res => {
              if (res.status === 208) {
                this.$toasted.error("username already in use");
                this.showUsernameSuggestion = true;
                this.suggestedUserName = res.data.usernames;
                // this.signUpObj.username = username
                // reject()
                resolve();
              } else if (res.status === 200) {
                this.$toasted.success("username available");
                this.showUsernameSuggestion = false;
                // this.signUpObj.username = username
                resolve();
              }
            })
            .catch(err => {
              console.log("ERROR_IN_CHECKING_AVAILABLE_USERNAME : ", err);
              reject(err);
            });
        });
      } else {
        this.$toasted.error("please fill proper details");
      }
    },
    handleOtpResend() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            SSO_URL + "/o/forgotpassword/resendotp",
            { username: this.userNameForPasswordReset },
            { headers: { ClientId: SSO_CLIENT_ID } }
          )
          .then(res => {
            this.$toasted.success("OTP sent");
            resolve();
          })
          .catch(err => {
            console.log("ERROR_IN_RESENDING_OTP : ", err);
            reject();
          });
      });
    },
    // reset - resets the flags and values
    reset() {
      this.togglePasswordInputType = true;
      this.isShown = false;
      this.userEnteredValue = "";
      this.isContactDetailsOtpSend = false;
      this.isLinkingOperationPerformed = false;
      this.userNameForPasswordReset = "";
      this.errors.clear();
      this.blockUi = false;
      this.fullname = "";
      this.date = "";
      this.genderSelected = "";
      this.signUpObj.personalDetails.fullName = null;
      this.signUpObj.contactDetails.email.address = null;
      this.signUpObj.contactDetails.mobile.number = null;
      this.signUpObj.userName = null;
      this.signUpObj.password = null;
      this.passwordMismatch = false;
      this.invalidOtp = false;
      this.invalidUsernameOtp = false;
      this.isOtpRequestSend = false;
      this.username = "";
      this.password = "";
      this.otpInput = "";
      this.confirmPassword = "";
      this.otpOptions = [];
      this.emptyUsername = false;
      this.emptyPassword = false;
      this.email = "";
      this.mobile = "";
      this.isLoginWithInvalidCredentials = false;
      this.emailAlreadyInUse = false;
      this.mobileAlreadyInUse = false;
      (this.isMultipleAccount = false),
        (this.isLinkingPermission = false),
        (this.associatedProfileId = ""),
        (this.contactMobile = "");
    },
    resetPasswordPolicyFlags() {
      this.strike_length = false;
      this.strike_cap_alpha = false;
      this.strike_no_char = false;
    },
    // handleRegistration - register user on liveDemy
    handleRegistration() {
      var errorList = "";
      var blankEmailError = false;
      var blankMobileError = false;
      var blankFullNameError = false;
      // check for full name
      if (
        this.fullname.trim().length === 0 ||
        !this.validateForTextInput(this.fullname, true)
      ) {
        blankFullNameError = true;
        errorList = "full name";
      }
      // check for email
      if (
        this.email.length === 0 ||
        (this.email.indexOf("@") < 1 ||
          this.email.lastIndexOf(".") < this.email.indexOf("@") + 2 ||
          this.email.lastIndexOf(".") + 2 >= this.email.length)
      ) {
        if (blankFullNameError) {
          errorList = errorList + ", email";
          blankEmailError = true;
        } else {
          blankEmailError = true;
          errorList = "email";
        }
      }
      // check for mobile
      if (
        this.mobile.length === 0 ||
        this.mobile.length < 10 ||
        !this.validateForNumberInput(this.mobile, true)
      ) {
        if (blankEmailError || blankFullNameError) {
          blankMobileError = true;
          errorList = errorList + ", mobile";
        } else {
          errorList = "mobile";
          blankMobileError = true;
        }
      }
      // check for valid password input
      this.validatePasswordInput(this.password).then(res => {
        if (!res) {
          // password not valid
          if (blankMobileError || blankEmailError || blankFullNameError) {
            errorList = errorList + ", password ";
          } else {
            errorList = "password";
          }
        }
        // no errors begin then encrypt password and begin Registration
        encrtpyDetailsUsingMd5(this.password).then(res => {
          // console.log(res)
          var encryptedPassword = res;
          if (errorList === "") {
            // if valid email, mobile and password entered by user
            return new Promise((resolve, reject) => {
              axios
                .post("o/registerUser", {
                  fullName: this.fullname.trim(),
                  userName: this.email,
                  accountDetails: [
                    {
                      jvId: LIVEDEMY_DEFAULT_USER,
                      email: this.email,
                      mobile: this.mobile,
                      isActive: true,
                      password: encryptedPassword
                    }
                  ],
                  roles: [LIVEDEMY_DEFAULT_USER_RIGHT],
                  linkingPermission: false
                })
                .then(res => {
                  if (res.status === 200) {
                    this.$toasted.success("Registration Successfull");
                    this.reset();
                    this.$refs.signupModal.hide();
                    this.$refs.loginModal.show();
                    resolve(true);
                  } else {
                    this.$toasted.errors("Something went wrong");
                    reject(false);
                  }
                })
                .catch(err => {
                  // console.log(JSON.stringify(err.response.data))
                  console.log("error in registration : ", err.response.data);
                  this.$toasted.error(err.response.data);
                  reject(false);
                });
            });
          } else {
            // invalid input entered by user
            // console.log(errorList)
            this.$toasted.error("Enter appropriate input for " + errorList);
          }
        });
      });
    },
    // isDuplicateEmailOrMobile - returns true if value for key is unique else false
    isDuplicateEmailOrMobile(key, value) {
      if (value.length !== 0) {
        return new Promise((resolve, reject) => {
          axios
            .post("o/isDuplicateEmailOrMobile", null, {
              headers: { key: key, value: value }
            })
            .then(res => {
              if (res.status === 200) {
                // value for key is unique
                resolve(true);
              } else if (res.status === 208) {
                // value for key is already in use
                resolve(false);
              }
            })
            .catch(err => {
              console.log("ERROR_IN_GETTING_UNIQUE_FEILD_STATUS : ", err);
              reject();
            });
        });
      }
    },
    // clearLocalStorage - clears the content from local storage
    clearLocalStorage() {
      return new Promise(resolve => {
        if (localStorage.length !== 0) {
          for (var i = 0; i < localStorage.length; i++) {
            localStorage.removeItem(localStorage.key(i));
            if (i + 1 === localStorage.length) {
              resolve(true);
            }
          }
        } else {
          resolve(true);
        }
      });
    },
    // handleOtpVerification - verifies user entered otp
    handleOtpVerification(evt) {
      evt.preventDefault();
      if (this.otpInput.length === 0) {
        this.$toasted.error("OTP field cannot be blanked");
      } else if (this.validateForNumberInput(this.otpInput, true) === false) {
        this.$toasted.error("OTP must contain only numeric characters");
      } else {
        return new Promise((resolve, reject) => {
          // console.log(SSO_URL + '/o/forgotpassword/verifyotp')
          this.blockUi = true;
          axios
            .post(
              SSO_URL + "/o/forgotpassword/verifyotp",
              { username: this.userNameForPasswordReset, otp: this.otpInput },
              { headers: { ClientId: SSO_CLIENT_ID } }
            )
            .then(res => {
              if (res.status === 200) {
                // console.log(JSON.stringify(res))
                // this.passwordChangeAuth = res.headers.authorization
                this.blockUi = false;
                this.invalidOtp = false;
                this.isOtpRequestSend = false;
                this.password = "";
                this.clearLocalStorage().then(response => {
                  localStorage.setItem(
                    "tokenForPasswordChange",
                    res.headers.authorization
                  );
                  this.tokenForPasswordChange = res.headers.authorization;
                  //  console.log(this.tokenForPasscwordChange)
                  this.$refs.passwordChangeModal.show();
                  this.$toasted.success("OTP Verifed");
                  resolve();
                });
              }
            })
            .catch(err => {
              this.blockUi = false;
              this.invalidOtp = true;
              console.log("ERROR_IN_VERIFIYNG_OTP : ", err);
              reject();
            });
        });
      }
    },
    // handleOtpRequest - sends the otp request
    handleOtpRequest(evt) {
      // Prevent modal from closing
      // evt.preventDefault()
      if (this.username.length === 0) {
        this.$toasted.error("Email / mobile number cannot be empty");
      } else {
        return new Promise((resolve, reject) => {
          this.blockUi = true;
          axios
            .post("o/getBasicProfile", null, {
              headers: { userName: this.username }
            })
            .then(res => {
              this.usernameFromAfficilatorApi = res.data.userName;
              this.isMultipleAccount = res.data.multipleAccounts;
              this.isLinkingPermission = res.data.linkingPermission;
              this.afficilator = res.data.afficilator;
              this.profileId = res.data.profileId;
              axios
                .post(
                  SSO_URL + "/o/login/validateusername",
                  { username: res.data.userName },
                  { headers: { ClientId: SSO_CLIENT_ID } }
                )
                .then(res => {
                  this.userNameForPasswordReset = res.data;
                  if (res.status === 200) {
                    axios
                      .post(
                        SSO_URL + "/o/forgotpassword/sendotp",
                        {
                          username: this.userNameForPasswordReset,
                          isemail: this.otpOptions[0]
                        },
                        { headers: { ClientId: SSO_CLIENT_ID } }
                      )
                      .then(res => {
                        if (res.status === 200) {
                          this.invalidUsernameOtp = false;
                          this.blockUi = false;
                          this.isOtpRequestSend = true;
                          this.$toasted.success("OTP sent");
                          resolve();
                        }
                      })
                      .catch(err => {
                        console.log("ERROR_IN_SENDING_OTP : ", err);
                        this.blockUi = false;
                        reject();
                      });
                  }
                })
                .catch(err => {
                  this.invalidUsernameOtp = true;
                  this.$toasted.error("Please enter registered mobile number");
                  // console.log(this.invalidUsernameOtp)
                  this.blockUi = false;
                  console.log("ERROR_IN_VALIDATING_USERNAME : ", err);
                  reject();
                });
            })
            .catch(err => {
              this.blockUi = false;
              console.log("ERROR_IN_GETTING_USERNAME : ", err);
              this.invalidUsernameOtp = true;
            });
        });
        // this.isOtpRequestSend = true
        // api to verify SSO
      }
    },
    // isUserContactEmpty - check if contact details are not empty
    isUserContactEmpty(contactDetails) {
      // console.log(JSON.stringify(contactDetails))
      return new Promise(resolve => {
        if (contactDetails === null) {
          // console.log('e')
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    // verifyEmailAndMobile - verifies whether the user entered details
    verifyEmailAndMobile(key, value) {
      return new Promise((resolve, reject) => {
        this.blockUi = true;
        this.contactMobile = this.userEnteredValue;
        axios
          .post("o/verifytheContactDetails", null, {
            headers: { key: "mobile", value: this.userEnteredValue }
          })
          .then(res => {
            // console.log('-->', JSON.stringify(res.data))
            this.associatedProfileId = res.data.profileId;
            this.userNameForPasswordReset = res.data.associatedUserName;
            // console.log('associated username : ', this.userNameForPasswordReset)
            if (res.data.remark === "AVAILABLE") {
              axios
                .post(
                  SSO_URL + "/o/login/validateusername",
                  { username: this.usernameFromAfficilatorApi },
                  { headers: { ClientId: SSO_CLIENT_ID } }
                )
                .then(res => {
                  if (res.status === 200) {
                    this.blockUi = false;
                    axios
                      .post(
                        SSO_URL + "/o/forgotpassword/sendotp",
                        {
                          username: this.usernameFromAfficilatorApi,
                          isemail: true
                        },
                        { headers: { ClientId: SSO_CLIENT_ID } }
                      )
                      .then(res => {
                        if (res.status === 200) {
                          this.blockUi = false;
                          this.$toasted.success("OTP sent");
                          this.isContactDetailsOtpSend = true;
                          resolve();
                        }
                      })
                      .catch(err => {
                        console.log("ERROR_IN_SENDING_OTP : ", err);
                        this.blockUi = false;
                        reject();
                      });
                  }
                })
                .catch(err => {
                  this.invalidUsernameOtp = true;
                  this.$toasted.error("Please enter registered mobile number");
                  // console.log(this.invalidUsernameOtp)
                  this.blockUi = false;
                  console.log("ERROR_IN_VALIDATING_USERNAME : ", err);
                  reject();
                });
            } else {
              this.$toasted.error(
                "Enter contact detail is associated with other account"
              );
              axios
                .post(
                  SSO_URL + "/o/forgotpassword/sendotp",
                  { username: this.userNameForPasswordReset, isemail: true },
                  { headers: { ClientId: SSO_CLIENT_ID } }
                )
                .then(res => {
                  if (res.status === 200) {
                    this.blockUi = false;
                    this.$toasted.success("OTP sent");
                    // this.usernameFromAfficilatorApi = this.userNameForPasswordReset
                    this.$refs.askCredentialModal.hide();
                    this.userEnteredValue = "";
                    this.$refs.otpVerificationForAccountLinkingModal.show();
                    resolve();
                  }
                })
                .catch(err => {
                  console.log("ERROR_IN_SENDING_OTP : ", err);
                  this.blockUi = false;
                  reject();
                });
            }
          })
          .catch(err => {
            console.log("ERROR_IN_VERIFYING_ACCOUNT_DETAILS : ", err);
            reject(err);
          });
      });
    },
    // verifyOtp - used during password linking
    verifyOtp(otpValue) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            SSO_URL + "/o/forgotpassword/verifyotp",
            { username: this.userNameForPasswordReset, otp: otpValue },
            { headers: { ClientId: SSO_CLIENT_ID } }
          )
          .then(res => {
            // console.log(JSON.stringify({'currentProfileId': this.profileId, 'newProfileId': this.associatedProfileId, 'afficilator': this.afficilator}))
            this.$toasted.success("OTP verified");
            axios
              .post("o/transferUserData", null, {
                headers: {
                  currentProfileId: this.profileId,
                  newProfileId: this.associatedProfileId,
                  afficilator: this.afficilator,
                  contact: this.contactMobile
                }
              })
              .then(res => {
                this.$toasted.success("ACCOUNT LINKED");
                this.reset();
                this.$refs.otpVerificationForAccountLinkingModal.hide();
                this.$refs.loginModal.show();
                resolve();
              })
              .catch(err => {
                console.log("ERROR_IN_TRANSFERING_ACCOUNT_DETAILS : ", err);
                reject();
              });
          })
          .catch(err => {
            console.log("ERROR_IN_VERIFYING_OTP : ", err);
            this.$toasted.error("Something went wrong");
            reject(err);
          });
      });
    },
    // addUserContactDetails - adds the user contact details to user profile
    addUserContactDetails() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "o/addUserContactDetails",
            {
              profileId: this.profileId,
              accountDetails: [{ jvId: this.afficilator }]
            },
            { headers: { key: "mobile", value: this.userEnteredValue } }
          )
          .then(res => {
            resolve(true);
          })
          .catch(err => {
            console.log("ERROR_IN_ADDING_CONTACT_DETAILS : ", err);
            reject(false);
          });
      });
    },
    // contactDetailsOtpVerification - called during otp verification during accountDetails
    contactDetailsOtpVerification() {
      if (this.otpInput.length === 0) {
        this.$toasted.error("OTP field cannot be blanked");
      } else if (this.validateForNumberInput(this.otpInput, true) === false) {
        this.$toasted.error("OTP must contain only numeric characters");
      } else {
        return new Promise((resolve, reject) => {
          this.blockUi = true;
          axios
            .post(
              SSO_URL + "/o/forgotpassword/verifyotp",
              { username: this.usernameFromAfficilatorApi, otp: this.otpInput },
              { headers: { ClientId: SSO_CLIENT_ID } }
            )
            .then(res => {
              if (res.status === 200) {
                this.addUserContactDetails().then(res => {
                  if (res) {
                    this.reset();
                    this.$refs.askCredentialModal.hide();
                    this.$toasted.success(
                      "Contact details updated, Please reLogin"
                    );
                    this.blockUi = false;
                    resolve();
                  } else {
                    this.$toasted.error("Something went wrong");
                    this.blockUi = false;
                    reject();
                  }
                });
              }
            })
            .catch(err => {
              console.log("ERROR_IN_OTP_VERIFICATION : ", err);
              this.blockUi = false;
              reject();
            });
        });
      }
    },
    // checkContactDetails - checks the user input
    checkContactDetails() {
      if (this.userEnteredValue.length !== 0) {
        this.verifyEmailAndMobile("mobile", this.value);
      } else {
        this.$toasted.error("Please fill details");
      }
    },
    // handleLogin - logins user through liveDemy form
    handleLogin(evt) {
      evt.preventDefault();
      if (this.username.length === 0 || this.password.length === 0) {
        // check for valid login input
        if (this.username.length === 0 && this.password.length === 0) {
          this.emptyUsername = true;
          this.emptyPassword = true;
        } else if (this.username.length === 0) {
          this.emptyUsername = true;
        } else {
          this.emptyPassword = true;
        }
      } else {
        // input valid
        // alert('in else')
        this.emptyUsername = false;
        this.emptyPassword = false;
        return new Promise((resolve, reject) => {
          encrtpyDetailsUsingMd5(this.password).then(res => {
            // generated encryptrd username
            this.blockUi = true;
            var encryptedPassword = res;
            this.tempUsername = this.username;
            axios
              .post("o/getBasicProfile", null, {
                headers: { userName: this.username }
              })
              .then(res => {
                this.afficilator = res.data.afficilator;
                this.profileId = res.data.profileId;
                this.usernameFromAfficilatorApi = res.data.userName;
                if (res.data.linkingPermission && res.data.multipleAccounts) {
                  // multiple account non - merged
                  this.$swal({
                    title:
                      "Hey user, your multiple accounts are merged. Do you want to maintain the common Password ?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true
                  }).then(isPermissionGiven => {
                    if (isPermissionGiven) {
                      this.isLinkingOperationPerformed = true;
                      this.$refs.loginModal.hide();
                      this.$refs.forgetPasswordModal.show();
                      this.handleOtpRequest();
                    } else {
                      if (res.data.afficilator === LIVEDEMY_DEFAULT_USER) {
                        // user registered via liveDemy
                        this.$store
                          .dispatch("userSignIn", {
                            username: res.data.userName,
                            password: encryptedPassword,
                            jvId: res.data.afficilator,
                            linkingPermission: res.data.linkingPermission
                          })
                          .then(
                            res => {
                              if (res === "success") {
                                this.$refs.loginModal.hide();
                                this.isLoginWithInvalidCredentials = false;
                                this.$toasted.success("Welcome user");
                                this.blockUi = false;
                                this.reset();
                                this.$store.dispatch("getMostSearchedWordList");
                                resolve();
                              }
                            },
                            error => {
                              if (error === 417) {
                                this.blockUi = false;
                                this.isLoginWithInvalidCredentials = true;
                                reject(error);
                              }
                            }
                          );
                      } else {
                        // user registered through jointVenture
                        //  console.log(res.data.afficilator)
                        // return new Promise((resolve, reject) => {
                        axios
                          .post("o/verifyJointVentureCredentials", {
                            username: this.username,
                            password: encryptedPassword,
                            jvId: res.data.afficilator
                          })
                          .then(res => {
                            this.$store
                              .dispatch("setUserStoreData", res.data)
                              .then(storeResponse => {
                                if (storeResponse) {
                                  localStorage.setItem("isLoggedIn", true);
                                  localStorage.setItem(
                                    "token",
                                    res.headers.token
                                  );
                                  localStorage.setItem("ssoToken", false);
                                  this.$toasted.success("Welcome user");
                                  this.blockUi = false;
                                  this.$refs.loginModal.hide();
                                  this.reset();
                                  this.$store.dispatch(
                                    "getMostSearchedWordList"
                                  );
                                  resolve();
                                } else {
                                  this.blockUi = false;
                                  this.$toasted.error("Something went wrong");
                                  reject();
                                }
                              });
                          })
                          .catch(err => {
                            console.log(
                              "ERROR_IN_VERIFYING_JOINT_VENTURE_USER : ",
                              err
                            );
                            reject(err);
                          });
                        // })
                      }
                    }
                  });
                } else if (
                  !res.data.linkingPermission &&
                  !res.data.multipleAccounts
                ) {
                  // single account
                  if (res.data.afficilator === LIVEDEMY_DEFAULT_USER) {
                    // user registered via liveDemy
                    this.$store
                      .dispatch("userSignIn", {
                        username: res.data.userName,
                        password: encryptedPassword,
                        jvId: res.data.afficilator,
                        linkingPermission: res.data.linkingPermission
                      })
                      .then(
                        res => {
                          if (res === "success") {
                            this.$refs.loginModal.hide();
                            this.isLoginWithInvalidCredentials = false;
                            this.$toasted.success("Welcome user");
                            this.blockUi = false;
                            this.reset();
                            this.$store.dispatch("getMostSearchedWordList");
                            resolve();
                          }
                        },
                        error => {
                          if (error === 417) {
                            this.blockUi = false;
                            this.isLoginWithInvalidCredentials = true;
                            reject(error);
                          }
                        }
                      );
                  } else {
                    // user registered through jointVenture
                    axios
                      .post("o/verifyJointVentureCredentials", {
                        username: this.username,
                        password: encryptedPassword,
                        jvId: res.data.afficilator
                      })
                      .then(res => {
                        if (res.data.profileDetails.accountDetails !== null) {
                          this.$store
                            .dispatch("setUserStoreData", res.data)
                            .then(storeResponse => {
                              if (storeResponse) {
                                localStorage.setItem("isLoggedIn", true);
                                localStorage.setItem(
                                  "token",
                                  res.headers.token
                                );
                                localStorage.setItem("ssoToken", false);
                                this.$toasted.success("Welcome user");
                                this.blockUi = false;
                                this.$refs.loginModal.hide();
                                this.reset();
                                this.$store.dispatch("getMostSearchedWordList");
                                resolve();
                              } else {
                                this.blockUi = false;
                                this.$toasted.error("Something went wrong");
                                reject();
                              }
                            });
                        } else {
                          this.$refs.loginModal.hide();
                          this.$refs.askCredentialModal.show();
                          this.$toasted.error(
                            "Hey user, please enter contact details to proceed"
                          );
                          this.blockUi = false;
                          resolve();
                        }
                      })
                      .catch(err => {
                        console.log(
                          "ERROR_IN_VERIFYING_JOINT_VENTURE_USER : ",
                          err
                        );
                        reject(err);
                      });
                  }
                } else if (
                  !res.data.linkingPermission &&
                  res.data.multipleAccounts
                ) {
                  // multiple merged
                  this.$store
                    .dispatch("userSignIn", {
                      username: res.data.userName,
                      password: encryptedPassword,
                      jvId: res.data.afficilator,
                      linkingPermission: res.data.linkingPermission
                    })
                    .then(
                      res => {
                        if (res === "success") {
                          this.$refs.loginModal.hide();
                          this.isLoginWithInvalidCredentials = false;
                          this.$toasted.success("Welcome user");
                          this.blockUi = false;
                          this.reset();
                          this.$store.dispatch("getMostSearchedWordList");
                          resolve();
                        }
                      },
                      error => {
                        if (error === 417) {
                          console.log("....");
                          this.blockUi = false;
                          this.isLoginWithInvalidCredentials = true;
                          reject();
                        }
                      }
                    );
                }
              })
              .catch(err => {
                this.blockUi = false;
                console.log("ERROR_IN_FETCHING_USERNAME_FOR_USER : ", err);
                this.isLoginWithInvalidCredentials = true;
                reject(err);
              });
          });
        });
      }
    },
    // handleCommonPasswordRequest - used to set the common password
    handleCommonPasswordRequest() {
      if (this.password.length === 0 || this.confirmPassword.length === 0) {
        this.$toasted.error("please enter details");
      } else if (this.password !== this.confirmPassword) {
        this.$toasted.error("password mismatch");
      } else {
        this.validatePasswordInput(this.password).then(res => {
          if (res) {
            return new Promise((resolve, reject) => {
              encrtpyDetailsUsingMd5(this.password).then(res => {
                var encryptedPassword = res;
                this.blockUi = true;
                axios
                  .post(
                    SSO_URL + "/o/forgotpassword/changepassword",
                    {
                      username: this.usernameFromAfficilatorApi,
                      password: encryptedPassword,
                      confirmpassword: encryptedPassword
                    },
                    { headers: { ClientId: SSO_CLIENT_ID } }
                  )
                  .then(res => {
                    if (res.status === 200) {
                      return new Promise((resolve, reject) => {
                        // console.log(this.userNameForPasswordReset)
                        // console.log(this.userName)
                        // console.log('tempUsername-->', this.tempUsername)
                        axios
                          .post("o/changeJointVenturePassword", {
                            profileId: this.profileId,
                            password: "",
                            jvId: this.afficilator
                          })
                          .then(response => {
                            if (response.status === 200) {
                              this.$toasted.success("Password reseted");
                              // this.$refs.passwordChangeModal.hide()
                              this.$refs.loginModal.show();
                              this.blockUi = false;
                              this.reset();
                              this.isLinkingOperationPerformed = false;
                              resolve();
                            }
                          })
                          .catch(err => {
                            console.log(
                              "ERROR_IN_CHANGING_JOINT_VENTURE_PASSWORD :",
                              err
                            );
                            this.reset();
                            this.blockUi = false;
                            thos.$toasted.error("Error in Reseting Password");
                            reject();
                          });
                      });
                    }
                  })
                  .catch(err => {
                    this.blockUi = false;
                    console.log("ERROR_IN_SENDING_RESETING_PASSWORD : ", err);
                    this.reset();
                    reject();
                  });
              });
            });
          } else {
            this.$toasted.success("Password doesn't match the guildelines");
            // resolve()
          }
        });
      }
    },
    // handlePasswordReset - reseting the password
    handlePasswordReset(evt) {
      // Prevent modal from closing
      if (this.confirmPassword.length === 0 && this.password.length === 0) {
        this.$toasted.error("Please fill details");
      } else if (this.confirmPassword != this.password) {
        this.$toasted.error("Password mismatched");
      } else {
        this.validatePasswordInput(this.password).then(res => {
          if (res) {
            this.blockUi = true;
            return new Promise((resolve, reject) => {
              encrtpyDetailsUsingMd5(this.password).then(res => {
                // get encrypted password
                var encryptedPassword = res;
                /*
                  if 2 cases :
                    case 1 : single account or merged account
                    case 2 : multiple non merged account
                */
                if (
                  (!this.isLinkingPermission && !this.isMultipleAccount) ||
                  (!this.isLinkingPermission && this.isMultipleAccount)
                ) {
                  // console.log('reset SSO')
                  axios
                    .post(
                      SSO_URL + "/o/forgotpassword/changepassword",
                      {
                        username: this.usernameFromAfficilatorApi,
                        password: encryptedPassword,
                        confirmpassword: encryptedPassword
                      },
                      { headers: { ClientId: SSO_CLIENT_ID } }
                    )
                    .then(response => {
                      this.blockUi = false;
                      this.$refs.passwordChangeModal.hide();
                      this.$refs.loginModal.show();
                      this.reset();
                      this.$toasted.success("Password reseted");
                      resolve();
                    })
                    .catch(err => {
                      console.log("ERROR_IN_UPDATING_SSO_PASSWORD : ", err);
                      this.$toasted.error("Something went wrong");
                      this.blockUi = false;
                      reject(err);
                    });
                } else if (this.isLinkingPermission && this.isMultipleAccount) {
                  if (this.afficilator === LIVEDEMY_DEFAULT_USER) {
                    // user registerd through liveDemy
                    axios
                      .post(
                        SSO_URL + "/o/forgotpassword/changepassword",
                        {
                          username: this.usernameFromAfficilatorApi,
                          password: encryptedPassword,
                          confirmpassword: encryptedPassword
                        },
                        { headers: { ClientId: SSO_CLIENT_ID } }
                      )
                      .then(response => {
                        this.blockUi = false;
                        this.reset();
                        this.$refs.passwordChangeModal.hide();
                        this.$refs.loginModal.show();
                        this.isLinkingOperationPerformed = false;
                        this.$toasted.success("Password reseted");
                        resolve();
                      })
                      .catch(err => {
                        // console.log('ERROR_IN_UPDATING_SSO_PASSWORD')
                        this.$toasted.error("Something went wrong : ", err);
                        this.blockUi = false;
                        reject(err);
                      });
                  } else {
                    // user registered through jvId
                    axios
                      .post("o/changeJointVenturePassword", {
                        profileId: this.profileId,
                        password: encryptedPassword,
                        jvId: this.afficilator
                      })
                      .then(response => {
                        if (response.status === 200) {
                          this.$toasted.success("Password reseted");
                          this.$refs.passwordChangeModal.hide();
                          this.$refs.loginModal.show();
                          this.blockUi = false;
                          this.reset();
                          this.isLinkingOperationPerformed = false;
                          resolve();
                        }
                      })
                      .catch(err => {
                        this.blockUi = false;
                        console.log("ERROR_IN_CHANGING_JV_PASSWORD : ", err);
                        reject();
                      });
                  }
                }
              }); // encryptedPassword ends
            }); // promise ends
          } else {
            this.$toasted.error("Password doesn't match the guidelines");
          }
        });
      }
    },
    isPresentInSuggestions(elementToSearch) {
      var isPresent = false;
      // console.log(this.suggestions)
      this.suggestions.forEach(function(element) {
        if (element === elementToSearch) {
          isPresent = true;
        }
      });
      return isPresent;
    },
    addTag(newTag) {
      if (!this.isPresentInSuggestions(newTag)) {
        this.suggestions.unshift(newTag);
      }
      this.searchText = newTag;
      this.onSearch(newTag);
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    checkNavStatus() {
      if (this.status !== undefined && this.status !== null && this.status) {
        return true;
      } else {
        return false;
      }
    },
    errorQuery() {
      if (
        this.searchText !== undefined &&
        this.searchText !== null &&
        this.searchText.length !== 0
      ) {
        var contentCategory = "";
        if (
          this.$store.getters.getProfileDetails === undefined ||
          this.$store.getters.getProfileDetails === null ||
          (Object.keys(this.$store.getters.getProfileDetails).length === 0 &&
            this.$store.getters.getProfileDetails.constructor === Object)
        ) {
          contentCategory = "LIVEDEMY";
        } else {
          contentCategory = this.$store.getters.getUserJvID(
            this.$store.getters.getProfileDetails.accountDetails
          );
        }
        this.$store
          .dispatch(
            "getSearchResult",
            {
              searchText: this.searchText,
              location: { coordinates: [0, 0] },
              userId: this.userId
            },
            { headers: { contentCategory: contentCategory } }
          )
          .then(
            response => {
              this.$store.dispatch("fetchSearchCategory").then(
                response => {
                  // this.searchText = ''
                  EventBus.$emit("searchEvent", this.searchText);
                  this.loading = false;
                  this.$router.push({
                    name: "searchPageAlt",
                    params: {
                      search: this.searchText
                    }
                  });
                },
                error => {
                  console.log(
                    this.$t("common.errors.error_fetching_category"),
                    error
                  );
                }
              );
            },
            error => {
              console.log(
                this.$t("common.errors.error_setting_search_data"),
                error
              );
            }
          );
      }
    },
    sendQuery() {
      // console.log('in sendQuery')
      if (
        this.searchText !== undefined &&
        this.searchText !== null &&
        this.searchText.length !== 0
      ) {
        this.$store
          .dispatch("getSearchResult", {
            searchText: this.searchText,
            location: { coordinates: [this.longitude, this.latitude] },
            userId: this.userId
          })
          .then(
            response => {
              this.$store.dispatch("fetchSearchCategory").then(
                response => {
                  // this.searchText = ''
                  EventBus.$emit("searchEvent", this.searchText);
                  this.loading = false;
                  this.$router.push({
                    name: "searchPageAlt",
                    params: {
                      search: this.searchText
                    }
                  });
                },
                error => {
                  console.log(
                    this.$t("common.errors.error_fetching_category"),
                    error
                  );
                }
              );
            },
            error => {
              console.log(
                this.$t("common.errors.error_setting_search_data"),
                error
              );
            }
          );
      }
    },
    sendSearchQuery(position) {
      // console.log('in sendSearchQuery')
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      // console.log(this.latitude, this.longitude)
      this.sendQuery();
    },
    handleRejection(error) {
      // console.log('handle rejection')
      switch (error.code) {
        case error.PERMISSION_DENIED:
          // console.log('User denied the request for Geolocation.')
          this.errorQuery();
          break;
        case error.POSITION_UNAVAILABLE:
          // console.log('Location information is unavailable.')
          this.errorQuery();
          break;
        case error.TIMEOUT:
          // console.log('The request to get user location timed out.')
          this.errorQuery();
          break;
        case error.UNKNOWN_ERROR:
          // console.log('An unknown error occurred.')
          this.errorQuery();
          break;
      }
    },
    onSearch(val) {
      this.loading = true;
      // storing search text
      this.$store.dispatch("changeSearchType", "all");
      this.searchText = val;
      // storing profileId
      if (this.isLoggedIn) {
        var profileDetails = this.$store.getters.getProfileDetails;
        if (profileDetails !== null && profileDetails.profileId != null) {
          this.userId = profileDetails.profileId;
        }
      }
      // asking permission to get Location
      if (this.caseFalse) {
        // console.log('supporting')
        navigator.geolocation.getCurrentPosition(
          this.sendSearchQuery,
          this.handleRejection,
          this.defaultOptions
        );
      } else {
        // console.log('Your browser doesn\'t support')
        this.errorQuery();
      }
    },
    getMostSearchedWordList() {
      this.$store.dispatch("getMostSearchedWordList");
    },
    signUp() {
      window.MKCLAPI.signUp();
    },
    checkOffer() {
      if (
        this.$store.getters.getOffers !== undefined &&
        this.$store.getters.getOffers !== null
      ) {
        if (this.$store.getters.getOffers.length !== 0) {
          return true;
        }
      } else {
        return false;
      }
    },
    login() {
      window.MKCLAPI.login();
    },
    exitFromMahademy() {
      var here = this;
      if (localStorage.getItem("app_env") === MAHADEMY_APP_ENV) {
        localStorage.removeItem("app_env");
        localStorage.removeItem("token");
        here.$store.dispatch("clearUserData");
        window.location = MAHADEMY_EXIT_URL;
      }
    },
    logout() {
      this.reset();
      if (JSON.parse(localStorage.getItem("ssoToken"))) {
        // if token is generated from SSO server call SSO API
        var header = this;
        window.MKCLAPI.logout()
          .then(function() {
            header.$store.dispatch("clearUserData");
            header.$router.push({ path: "/advertisement" });
          })
          .catch(function(err) {
            console.log(err);
          });
      } else if (localStorage.getItem("mobileDevice")) {
        sendMessageToAndroid("logout");
        var header = this;
        window.MKCLAPI.logout()
          .then(function() {
            header.$store.dispatch("clearUserData");
            header.$router.push({ path: "/advertisement" });
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        // if token is generated by liveDemy server then call liveDemy api
        // console.log('here...')
        this.$store.dispatch("clearUserData");
        // this.$store.dispatch('logoutThirdPartyUser').then(res => {
        //   this.$store.dispatch('clearUserData')
        //   this.$router.push({path: '/advertisement'})
        // }, err => {
        //   console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err)
        // })
      }
    },
    goToSearchPage(id) {
      // console.log(id)
      if (id === "allBtn") {
        this.$store.dispatch("changeSearchType", "all").then(
          response => {},
          error => {
            console.log(
              this.$t("common.errors.error_changing_search_type"),
              error
            );
          }
        );
      } else if (id === "courseBtn") {
        this.$store.dispatch("changeSearchType", "CO").then(
          response => {},
          error => {
            console.log(
              this.$t("common.errors.error_changing_search_type"),
              error
            );
          }
        );
      } else {
        this.$store.dispatch("changeSearchType", "LO").then(
          response => {},
          error => {
            console.log(
              this.$t("common.errors.error_changing_search_type"),
              error
            );
          }
        );
      }
      // window.scrollTo(0, 0)
      this.searchText = this.$store.getters.getSearchText;
      this.$store.dispatch("removePreviousSearchResult").then(
        response => {
          if (
            this.searchText !== undefined &&
            this.searchText !== null &&
            this.searchText.length !== 0
          ) {
            // storing profileId
            if (this.isLoggedIn) {
              var profileDetails = this.$store.getters.getProfileDetails;
              if (profileDetails !== null && profileDetails.profileId != null) {
                this.userId = profileDetails.profileId;
              }
            }
            let caseFalse = false;
            // asking permission to get Location
            if (caseFalse) {
              // if (navigator.geolocation) {
              // console.log('supporting')
              navigator.geolocation.getCurrentPosition(
                this.sendSearchQuery,
                this.handleRejection,
                this.defaultOptions
              );
            } else {
              // console.log('Your browser doesn\'t support')
              this.errorQuery();
            }
          } else {
            this.$router.push({ path: "/searchPageAlt" });
          }
        },
        error => {
          console.log(
            "error in clearing search store data from SEARCHCARDALT",
            error
          );
        }
      );
      // this.$router.push({ path: '/searchPageAlt' })
    },
    getSuggestions(searchText) {
      var banner = this;
      if (searchText.length === 0) {
        this.suggestions = [];
        // this.searchText = ''
        return;
      } else if (searchText.length >= 2) {
        var contentCategory = "";
        if (
          this.$store.getters.getProfileDetails === undefined ||
          this.$store.getters.getProfileDetails === null ||
          (Object.keys(this.$store.getters.getProfileDetails).length === 0 &&
            this.$store.getters.getProfileDetails.constructor === Object)
        ) {
          contentCategory = DEFAULT_OBJECT_CATEGORY;
        } else {
          contentCategory = this.$store.getters.getUserJvID(
            this.$store.getters.getProfileDetails.accountDetails
          );
        }
        this.previousSuggestionsForSearchText = searchText;
        axios
          .post(
            "o/getSuggestionBasedOnKeyword",
            { searchText: searchText },
            { headers: { contentCategory: contentCategory } }
          )
          .then(function(res) {
            if (res.status === 200) {
              // alert(res.data.length)
              banner.suggestions = res.data;
              // banner.suggestions.unshift(banner.searchText)
            }
          });
      }
    },
    getSignUpStatus() {
      axios
        .get("o/getsignupstatus", null)
        .then(res => {
          this.signUpStatus = res.data;
        })
        .catch(e => {
          console.log("err in getting signUp status :", e);
        });
    },
    getFeatureStatusInfoList() {
      axios
        .get("o/features/getfeaturesinfolist")
        .then(res => {
          this.featureList = res.data;
        })
        .catch(e => {
          console.log("error in getting feature list : ", e);
        });
    }
  },
  mounted() {
    // alert(123)
    // this.getSignUpStatus()
    this.getFeatureStatusInfoList();
    this.$store.dispatch("fetchAllOffersFromDb").then(
      response => {},
      error => {
        console.error("error in fertching offers", error);
      }
    );
    window.addEventListener("scroll", this.updateScroll);
  },
  computed: {
    basicProfile() {
      return this.$store.getters.getProfileDetails;
    },
    isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  }
};
</script>
<style src="@/../static/css/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../../../static/assets/styles/scss/variables.scss";

.strikethrough {
  text-decoration: line-through;
}
.error {
  color: red;
}
#login,
#signup,
#forgetPassword,
#passwordChange {
  margin-top: 4%;
  h5 {
    text-align: center;
  }
  .modal-title {
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
  .modal-content {
    padding: 25px;
  }
  .sub-title {
    font-size: 14px;
    font-weight: 600;
  }
  .newuser {
    margin-top: 20px;
  }
  .newusertc {
    margin: 20px auto;
    color: #777;
  }
  .social {
    @mixin socialbtn($color1) {
      margin: 10px 15px 15px 0px;
      color: $color1;
      background-color: #fff;
      border: 1px solid $color1;
      border-radius: 4px;
      padding: 5px 10px;
      // .fa{padding-right:8px;}
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        background-color: $color1;
        color: #fff;
      }
      &:focus {
        color: #ffffff;
        background-color: darken($color1, 5%);
      }
      &:active {
        box-shadow: 0px 0px 5px #55bef7;
      }
    }
    .fb {
      @include socialbtn(#3b5998);
    }
    .google {
      @include socialbtn(#db4733);
    }
    .twitter {
      @include socialbtn(#1da1f3);
    }
  }
  .input-group {
    box-shadow: none;
    border-radius: 4px;
    margin: 10px auto;
    input {
      font-size: 14px;
      font-weight: 400;
      font-family: $montserrat;
    }
  }
  .form-control {
    box-shadow: none;
    border: none;
    background-color: #efefef;
    padding: 15px;
  }
  .input-group-addon {
    .fa-lock {
      font-size: 18px;
      margin-right: -2px;
    }
    .fa-envelope {
      font-size: 13px;
      margin-right: -3px;
    }
    background-color: #efefef;
    border: none;
    color: #555;
    border-right: 0px;
  }
  .forgotpwd {
    margin: 10px auto 20px auto;
    font-size: 12px;
    a {
      color: #777;
    }
  }
  .login-btn {
    background-color: #3e62be;
    border: 0px;
    // border:1px solid #3e62be;
    text-align: center;
    color: #fff;
    display: block;
    box-shadow: none;
    &:hover {
      background-color: darken(#3e62be, 7%);
      color: #fff;
    }
  }
  .resend-otp {
    padding-top: 10px;
    // color:#777;
  }
}

#topnav {
  text-align: center;
  .offers {
    line-height: 22px;
  }
  .user-links {
    margin-top: 5px;
    a {
      padding: 0 8px;
    }
  }
}

.logo-holder a {
  padding: 14px 0;
  height: 80px;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease-out;
  img {
    height: 100%;
    max-height: 44px;
  }
}

.header-login {
  position: relative;
  z-index: 100;
  .active {
    background: linear-gradient(to right, #77b3f1, #98a2f7);
    border-radius: 2px;
    color: #fff;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
  }

  .inActive {
    background-color: transparent;
  }

  .input-group {
    input {
      font-size: 14px;
      box-shadow: none;
      border-radius: 3px;
      padding: 15px;
    }
    .input-group-prepend {
      // border:1px solid rgba(0, 0, 0, 0.15);
      // border-left:0px;
      border: 0px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      background-color: #e8e8e8;
      margin-left: -0px;
      box-shadow: none;
      z-index: 2;
      span {
        background-color: #e8e8e8;
      }
    }
    .form-control {
      // border-radius: 4px;
      background-color: #e8e8e8;
      border-right: 0px;
      box-shadow: none;
      border: 0px;
      z-index: 3;
      &:focus,
      &:active {
        border-color: rgba(0, 0, 0, 0.15);
      }
    }
    .input-group-prepend:not(:first-child) {
      .input-group-text {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: #e8e8e8;
      }
    }
    .input-group-text {
      font-size: 20px;
      border: none;
      padding-left: 10px;
      padding-right: 15px;
      cursor: pointer;
      color: darken(#888, 8%);
      background-color: #fff;
      &:hover,
      &:active {
        .fa {
          color: #333;
        }
        box-shadow: none;
      }
    }
  }
  .container-fluid {
    margin: 0px;
  }
  #topnav {
    font-family: $opensans;
    background: #373737;
    color: #fafafa;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    padding-top: 0px;
    padding-bottom: 0px;
    div {
      a {
        font-size: 11px;
        color: #fff;
        text-decoration: none;
        span {
          text-transform: uppercase;
          padding: 0px 20px;
          display: inline-block;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .info-text {
        cursor: default;
      }
    }
    .nav-t {
      a {
        color: #fafafa;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  #main-header {
    /*padding-top: 8px; padding-bottom:8px;*/
    background-color: #fff;
    .menu-y {
      padding-top: 9px;
      padding-bottom: 9px;
    }
    .menu-links {
      span {
        font-weight: 600;
        cursor: pointer;
        font-size: 14px;
        letter-spacing: 0.7px;
        text-transform: uppercase;
        padding: 6px 22px;
        display: inline-block;
        margin-right: 10px;
        margin-left: 10px;
      }
      .select-tag {
        padding: 10px 22px;
        border-radius: 3px;
        color: #fafafa;
        background: #79b2f2;
      }
    }
    .nav-t {
      font-weight: 600;
      text-transform: uppercase;
      a {
        color: #333;
        font-size: 13px;
        &:hover {
          color: #2599d3;
        }
      }
    }
    .icons-css {
      padding-right: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: right;
      font-size: 24px;
      cursor: pointer;
      margin-right: 0px;
      transition: all 0.3s;
      position: relative;
      top: 3px;
      > a {
        position: relative;
        padding: 10px;
        display: block;
      }
      .wishlist {
        color: #ff6c8a;
        &:hover {
          color: darken(#ff6c8a, 10%);
        }
      }
      .cart {
        color: #3e62be;
        &:hover {
          color: darken(#3e62be, 15%);
        }
      }
      .wallet {
        color: #7ac600;
        &:hover {
          color: darken(#7ac600, 10%);
        }
      }
      .course {
        color: #48b5de;
        &:hover {
          color: darken(#48b5de, 10%);
        }
      }
      .count {
        height: 16px;
        width: 16px;
        border-radius: 20px;
        font-size: 8px;
        color: #fff;
        background-color: #474747;
        box-shadow: 0 0 0 2px #fff;
        display: inline-block;
        padding: 2px 4px;
        line-height: 12px;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        position: absolute;
        top: 2px;
        right: 2px;
        z-index: 1;
        font-family: $opensans;
        font-weight: 600;
      }
    }
    .box-user {
      img {
        border-radius: 50px;
        width: 38px;
        height: 38px;
        border: 1px solid #eee;
      }
      .dropdown {
        > .btn {
          padding: 1px 5px;
        }
        .mdi-chevron-down {
          display: none;
          font-size: 24px;
          line-height: 20px;
          color: #888;
        }
        .dropdown-menu {
          min-width: 11rem;
        }
        .dropdown-item {
          display: flex;
          flex-direction: row;
          border-radius: 0;
          font-size: 13px;
          line-height: 24px;
          font-weight: 500;
          color: #555;
          i {
            margin-right: 6px;
            font-size: 16px;
          }
          &:active,
          &:hover,
          &:focus {
            background: #eee;
            color: #333;
            box-shadow: none;
          }
          &.active {
            background: #ddd;
            box-shadow: none;
          }
        }
      }
    }
  }
}

.navbar {
  padding: 0;
  > .row {
    width: 100%;
  }
  .w-100 {
    order: 3;
  }
  .col-collapse {
    order: 4;
  }
}
.navbar-brand {
  margin-right: 0;
  padding: 14px 0;
  height: 80px;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease-out;
  img {
    height: 100%;
    max-height: 30px;
  }
}
.m-links-holder {
  padding: 5px 0;
  text-align: center;
}
.h-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  .h-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .h-links {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    a {
      padding: 4px 3px;
      display: inline-block;
      color: #333;
      &:hover {
        color: #2599d3;
      }
    }
  }
  .navbar-toggler {
    margin-left: 3px;
    padding: 3px 6px;
  }
  .navbar-toggler-icon {
    width: 20px;
    height: 20px;
  }
}
.m-search-holder {
  position: relative;
  padding: 5px 0;
  margin: 0 auto;
  width: 100%;
  .multiselect {
    &__tags {
      padding-right: 50px;
      height: 50px;
      border: none;
      border-radius: 3px;
      background: #e8e8e8;
      transition: all 0.2s ease-out;
    }
    &__select {
      padding: 4px 12px;
      width: 50px;
      text-align: center;
      transform: rotate(0) !important;
      &:before {
        top: 0;
        content: "\f349";
        margin: 0;
        height: 48px;
        border: none;
        font-size: 24px;
        line-height: 40px;
        font-family: "Material Design Icons";
        transition: all 0.2s ease-out;
      }
    }
    &__single {
      margin: 0;
      padding: 0 10px;
      font-size: 13px;
      line-height: 34px;
      color: #6c757d;
      background: #e8e8e8;
    }
    &__input {
      margin: 0;
      padding: 0 10px;
      font-size: 13px;
      line-height: 34px;
      font-weight: 400;
      background: transparent;
      box-shadow: none;
      &::placeholder {
        color: #35495e;
        opacity: 0.6;
      }
    }
    &__content-wrapper {
      border: none;
      border-top: 1px solid #e0e0e0;
      border-radius: 0 0 3px 3px;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    }
    &__option {
      padding: 12px 20px;
      font-size: 14px;
      &--highlight {
        background: #63bef0;
        &:after {
          background: #63bef0;
        }
      }
    }

    &.multiselect--active {
      /*.multiselect__tags {box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.35);}*/
      .multiselect__select:before {
        color: #000;
      }
    }
  }

  .ms-loader {
    position: absolute;
    top: 17px;
    right: 50px;
  }
}

@media (min-width: 360px) {
  .d-xs3-block {
    display: block !important;
  }
  .d-xs3-none {
    display: none !important;
  }
}

@media (min-width: 360px) and (max-width: 400px) {
  .header-login #main-header .icons-css > a {
    padding-left: 4px;
    padding-right: 4px;
  }
}

@media (min-width: 768px) {
  #topnav {
    text-align: left;
    .user-links {
      margin-top: 0;
      text-align: right;
    }
  }

  .header-login.onn {
    padding-bottom: 80px;
    #main-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    }
    /*.logo-holder a {height: 60px;}*/
    .navbar-brand {
      height: 60px;
    }
  }
  .modal-open .header-login.onn {
    #main-header {
      padding-right: 17px;
    }
  }
  .h-right {
    .h-links {
      font-size: 13px;
      a {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }

  .header-login #main-header .box-user {
    padding-right: 5px;
    img {
      margin-right: 6px;
      width: 44px;
      height: 44px;
    }
    .dropdown {
      > .btn {
        padding-left: 12px;
        padding-right: 5px;
      }
      .mdi-chevron-down {
        display: none;
      }
    }
  }

  .navbar-brand {
    img {
      max-height: 44px;
    }
  }
  .m-search-holder {
    width: 90%;
  }
}

@media (min-width: 992px) {
  .header-login #main-header .menu-links span {
    padding-left: 16px;
    padding-right: 16px;
    margin-left: 2px;
    margin-right: 2px;
  }

  .navbar {
    .w-100 {
      order: 0;
    }
    .col-collapse {
      order: 0;
    }
  }
}

@media (min-width: 1200px) {
  .header-login #main-header .menu-links span {
    padding-left: 22px;
    padding-right: 22px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
#radios1,
#otpcheck {
  label {
    cursor: pointer;
  }
  span {
    padding-left: 5px;
  }
}
.help-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 101;
  font-size: 20px;
  color: #3e62be;
}

.mfs-logo {
  .navbar-brand {
    padding: 0px;
  }
  .navbar-brand img {
    max-height: 55px;
  }
}
.maha-demy {
  .navbar-brand {
    padding: 5px 0px;
    vertical-align: middle;
  }
  .navbar-brand img {
    max-height: 100px;
  }
}
.with-icon {
  position: relative;
  padding-right: 50px;
  z-index: 10;
  ~ .input-icon {
    position: absolute;
    right: 15px;
    top: 13px;
    z-index: 101;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/headerLogin.vue?bde57f8c